var _defs, _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _g2, _g3, _g4, _g5, _g6, _g7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataVisualizationReportingBi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 727.16 683.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8 {\n        fill: none;\n      }\n\n      .cls-2 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-3 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-5 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-6 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-7 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-9 {\n        fill: #002c5f;\n      }\n\n      .cls-8 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 414.7,
    y: 8.13,
    width: 55.27,
    height: 54.96
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 27.35,
    y: 133.66,
    width: 168.61,
    height: 16.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 27.35,
    y: 90.14,
    width: 228.58,
    height: 16.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 27.35,
    y: 45.46,
    width: 302.67,
    height: 16.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 27.35,
    y: 193.63,
    width: 551.99,
    height: 375.15
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 27.35,
    y: 484.11,
    width: 551.99,
    height: 16.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 198.31,
    y: 552.32,
    width: 209.33,
    height: 113.79
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m509.39,455.15H96.65c-4.3,0-7.8-3.49-7.8-7.8s3.49-7.8,7.8-7.8h412.74c4.3,0,7.8,3.49,7.8,7.8s-3.5,7.8-7.8,7.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m206.36,455.15h-84.56c-4.3,0-7.8-3.49-7.8-7.8v-183.25c0-10.96,8.92-19.88,19.88-19.88h60.41c10.96,0,19.88,8.92,19.88,19.88v183.23c-.02,4.32-3.49,7.81-7.81,7.81Zm-76.76-15.59h68.99v-175.45c0-2.32-1.97-4.29-4.29-4.29h-60.41c-2.32,0-4.29,1.96-4.29,4.29v175.45Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m345.31,455.15h-84.58c-4.3,0-7.8-3.49-7.8-7.8V189.78c0-11.05,9-20.04,20.04-20.04h60.08c11.06,0,20.04,9,20.04,20.04v257.58c.01,4.3-3.48,7.8-7.78,7.8Zm-76.78-15.59h68.99v-249.78c0-2.42-2.04-4.44-4.44-4.44h-60.08c-2.42,0-4.44,2.04-4.44,4.44v249.78h-.02Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m484.24,455.15h-84.58c-4.3,0-7.8-3.49-7.8-7.8V105.2c0-11.05,8.98-20.03,20.03-20.03h60.1c11.06,0,20.04,8.99,20.04,20.03v342.16c0,4.3-3.48,7.8-7.8,7.8Zm-76.77-15.59h68.99V105.2c0-2.42-2.04-4.44-4.45-4.44h-60.09c-2.4,0-4.45,2.04-4.45,4.44v334.36Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m164.08,221.17c-14.84,0-26.93-12.09-26.93-26.93s12.09-26.93,26.93-26.93,26.93,12.09,26.93,26.93-12.08,26.93-26.93,26.93Zm0-38.27c-6.25,0-11.33,5.09-11.33,11.34s5.08,11.34,11.33,11.34,11.34-5.09,11.34-11.34-5.1-11.34-11.34-11.34Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m303.02,146.67c-14.85,0-26.93-12.09-26.93-26.93s12.08-26.93,26.93-26.93,26.93,12.08,26.93,26.93-12.09,26.93-26.93,26.93Zm0-38.27c-6.25,0-11.34,5.09-11.34,11.34s5.09,11.34,11.34,11.34,11.33-5.09,11.33-11.34-5.08-11.34-11.33-11.34Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m441.95,62.09c-14.84,0-26.93-12.09-26.93-26.93s12.09-26.93,26.93-26.93,26.93,12.09,26.93,26.93-12.07,26.93-26.93,26.93Zm0-38.25c-6.25,0-11.33,5.08-11.33,11.33s5.08,11.34,11.33,11.34,11.34-5.08,11.34-11.34-5.09-11.33-11.34-11.33Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m180.94,192.99c-2.78,0-5.48-1.49-6.88-4.12-2.04-3.79-.61-8.51,3.18-10.56l105.22-56.41c3.8-2.03,8.51-.61,10.56,3.18s.61,8.51-3.18,10.56l-105.22,56.42c-1.17.64-2.43.93-3.68.93Zm138.43-75.41c-2.63,0-5.19-1.32-6.67-3.74-2.25-3.68-1.08-8.48,2.6-10.71l106.25-64.68c3.68-2.25,8.47-1.07,10.71,2.6,2.25,3.68,1.08,8.48-2.6,10.71l-106.25,64.68c-1.26.78-2.66,1.13-4.04,1.13Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m188.11,150.08H35.09c-4.3,0-7.8-3.49-7.8-7.8s3.49-7.8,7.8-7.8h153.03c4.3,0,7.8,3.49,7.8,7.8s-3.48,7.8-7.8,7.8Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m247.62,105.78H35.09c-4.3,0-7.8-3.49-7.8-7.8s3.49-7.8,7.8-7.8h212.53c4.3,0,7.8,3.49,7.8,7.8s-3.49,7.8-7.8,7.8Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m322.12,61.48H35.09c-4.3,0-7.8-3.5-7.8-7.8s3.49-7.8,7.8-7.8h287.03c4.3,0,7.8,3.5,7.8,7.8s-3.49,7.8-7.8,7.8Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m538.16,567.94H67.88c-22.38,0-40.59-18.21-40.59-40.59V234.33c0-22.38,18.21-40.59,40.59-40.59h78.53c4.3,0,7.8,3.5,7.8,7.8s-3.49,7.8-7.8,7.8h-78.53c-13.78,0-24.99,11.21-24.99,24.99v293.03c0,13.79,11.21,24.99,24.99,24.99h470.3c13.78,0,24.99-11.21,24.99-24.99v-254.57c0-4.3,3.49-7.8,7.8-7.8s7.8,3.5,7.8,7.8v254.55c-.01,22.39-18.23,40.59-40.6,40.59Zm-21.81-358.6h-32.11c-4.3,0-7.8-3.5-7.8-7.8s3.5-7.8,7.8-7.8h32.11c4.3,0,7.8,3.5,7.8,7.8s-3.5,7.8-7.8,7.8Zm-116.65,0h-54.39c-4.3,0-7.8-3.5-7.8-7.8s3.49-7.8,7.8-7.8h54.39c4.3,0,7.8,3.5,7.8,7.8s-3.5,7.8-7.8,7.8Zm-138.97,0h-78.96c-4.3,0-7.8-3.5-7.8-7.8s3.5-7.8,7.8-7.8h78.96c4.3,0,7.8,3.5,7.8,7.8s-3.49,7.8-7.8,7.8Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m570.95,500.31H35.09c-4.3,0-7.8-3.49-7.8-7.8s3.49-7.8,7.8-7.8h535.86c4.3,0,7.8,3.49,7.8,7.8s-3.5,7.8-7.8,7.8Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m399.13,666.3h-192.23c-2.81,0-5.39-1.51-6.78-3.96-1.39-2.45-1.34-5.44.09-7.86l59.02-98.36c2.21-3.7,7.01-4.9,10.7-2.67,3.69,2.21,4.9,7,2.68,10.7l-51.94,86.56h164.68l-51.94-86.56c-2.21-3.7-1.01-8.48,2.67-10.7,3.69-2.21,8.48-1.02,10.69,2.67l59.02,98.36c1.45,2.4,1.48,5.41.09,7.86-1.36,2.46-3.95,3.96-6.75,3.96Z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m345.03,534.14h-84.02c-4.3,0-7.8-3.5-7.8-7.8s3.5-7.8,7.8-7.8h84.02c4.3,0,7.8,3.5,7.8,7.8s-3.49,7.8-7.8,7.8Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m611.98,289.59c-36.21,0-71.46-18.77-90.83-52.31-28.86-49.99-11.68-114.12,38.31-142.99,14.52-8.37,30.31-13.05,46.93-13.91,2.51-.13,4.9.95,6.45,2.88,1.58,1.93,2.12,4.5,1.47,6.92l-29.58,110.37,110.37,29.58c2.4.64,4.37,2.4,5.26,4.72s.62,4.94-.74,7.03c-9.04,13.97-20.98,25.32-35.5,33.7-16.42,9.5-34.4,14-52.14,14Zm-15.67-192.42c-10.17,1.78-19.91,5.33-29.05,10.62-42.54,24.56-57.17,79.15-32.61,121.69,24.56,42.54,79.15,57.17,121.69,32.61,9.14-5.29,17.09-11.93,23.72-19.85l-106.87-28.65c-2-.53-3.7-1.84-4.74-3.63-1.04-1.79-1.31-3.91-.78-5.91l28.65-106.87Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m705.38,217.81c-.67,0-1.36-.09-2.01-.27l-93.57-25.07c-2-.53-3.7-1.84-4.74-3.63-1.05-1.8-1.31-3.91-.78-5.91l25.07-93.57c1.11-4.17,5.4-6.63,9.55-5.52,27.01,7.24,49.58,24.56,63.56,48.78,13.99,24.21,17.7,52.42,10.46,79.43-.53,2-1.84,3.7-3.63,4.74-1.19.67-2.54,1.03-3.9,1.03Zm-84.03-38.39l78.2,20.96c3.67-20.61,0-41.65-10.58-59.99-10.59-18.33-26.97-32.03-46.65-39.17l-20.96,78.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataVisualizationReportingBi);
export default __webpack_public_path__ + "static/media/Data Visualization & Reporting_BI.9410fd8b657e50d3a97be5d6d4e80577.svg";
export { ForwardRef as ReactComponent };